export default __webpack_public_path__ + "static/8_28-88b117ca6f83a7c19060a85405998185.png";